import type { Page } from '@inertiajs/core';
import { Capacitor } from '@capacitor/core';

export const LOCKED_LOCALE = 'pt_BR' as const;

export type AppLocale = 'pt_BR' | 'en';

export function isLocaleLockedToPortuguese(): boolean {
  if (import.meta.env.VITE_APP_LOCALE === LOCKED_LOCALE) {
    return true;
  }

  if (import.meta.env.VITE_MOBILE_BUNDLED === 'true') {
    return true;
  }

  return Capacitor.isNativePlatform();
}

/**
 * Idioma inicial do Vue I18n. App mobile/APK: sempre pt_BR (não depende do servidor/cookie).
 */
export function resolveAppLocale(page?: Page | null): AppLocale {
  if (isLocaleLockedToPortuguese()) {
    return LOCKED_LOCALE;
  }

  const fromPage = page?.props?.locale;
  if (fromPage === 'pt_BR' || fromPage === 'en') {
    return fromPage;
  }

  return 'en';
}

export function applyLockedLocaleCookie(): void {
  if (typeof document === 'undefined' || !isLocaleLockedToPortuguese()) {
    return;
  }

  const maxAge = 365 * 24 * 60 * 60;
  document.cookie = `locale=${LOCKED_LOCALE};path=/;max-age=${maxAge};SameSite=Lax`;
}
